import { render, staticRenderFns } from "./DepartmentChart.vue?vue&type=template&id=1a141911"
import script from "./DepartmentChart.vue?vue&type=script&lang=js"
export * from "./DepartmentChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports